module.exports = __webpack_public_path__ + "media/images/gallery/3-a58d0ad63b2476efb92bc857890bcfa8.jpg";